import React from 'react';
import { ICellRendererParams } from 'ag-grid-enterprise';

export const columnDefs = [
    {
        headerName: 'Paid',
        field: 'inspectionPaid',
        cellRenderer: (params: ICellRendererParams) => {
            return params.data.isInspectionPaid ? '<i class="fa fa-check" />' : '';
        },
    },
    {
        headerName: 'Received',
        field: 'inspectionReceived',
        cellRenderer: (params: ICellRendererParams) => {
            return params.data.isInspectionReceived ? '<i class="fa fa-check" />' : '';
        },
    },
    {
        headerName: 'Named Insured',
        field: 'namedInsured',
    },
    {
        headerName: 'Policy #',
        field: 'policyNumber',
    },
    {
        headerName: 'Inspection Location Name',
        field: 'locationName',
        cellRenderer: (params: ICellRendererParams) => (
            <a href={`/submission/${params.data.submissionId}/location/${params.data.locationId}`} target={'_blank'}>
                {params.value}
            </a>
        ),
    },
    {
        headerName: 'Ordered Date',
        field: 'inspectionOrderedDate',
    },
    {
        headerName: 'Received Date',
        field: 'inspectionReceivedDate',
    },
    {
        headerName: 'Inspection Location Address 1',
        field: 'locationAddress',
        cellRenderer: (params: ICellRendererParams) => (
            <a href={`/submission/${params.data.submissionId}/location/${params.data.locationId}`} target={'_blank'}>
                {params.value}
            </a>
        ),
    },
    {
        headerName: 'City',
        field: 'locationCity',
    },
    {
        headerName: 'State',
        field: 'locationState',
    },
    {
        headerName: 'Zip',
        field: 'locationZip',
    },
    {
        headerName: 'Contact First & Last Name',
        field: 'inspectionContactName',
    },
    {
        headerName: 'Contact Phone',
        field: 'inspectionContactPhone',
    },
    {
        headerName: 'Contact Email',
        field: 'inspectionContactEmail',
    },
];
